/**
 * AxLabs Mathematics Experiments
 *
 * Main export file for all mathematics laboratory experiments.
 */
// Number Systems experiments
export { PrimeDistributionExplorer, DivisibilityPatternInvestigator, GCDLCMRelationshipLab, ModularArithmeticCycles, DecimalExpansionBehavior, PerfectNumberInvestigation, FactorialGrowthAnalysis, BaseConversionPatterns, } from './generated/number-systems.js';
// Algebra experiments
export { QuadraticRootBehavior, PolynomialDegreeEffects, SystemOfEquationsSolutionSpace, InequalityRegionMapping, AbsoluteValueTransformations, ExponentialVsLinearGrowth, LogarithmicScalingBehavior, ComplexNumberPlaneMapping, } from './generated/algebra.js';
// Functions experiments
export { DomainRangeExplorer, CompositionOfFunctions, InverseFunctionSymmetry, PiecewiseFunctionContinuity, EvenOddFunctionSymmetry, FunctionTranslationEffects, PeriodicFunctionBehavior, } from './generated/functions.js';
// Geometry experiments
export { TriangleInequalityInvestigation, CircleChordProperties, AngleSumVerification, SimilarityRatioEffects, CoordinateDistanceFormula, LocusPointInvestigation, TransformationComposition, } from './generated/geometry.js';
// Trigonometry experiments
export { UnitCircleExploration, SineWaveParameterEffects, TrigonometricIdentityVerification, PhaseShiftAnalysis, AmplitudeAndPeriodRelationship, InverseTrigDomainBehavior, LawOfSinesCosinesApplication, PolarCoordinateMapping, } from './generated/trigonometry.js';
// Probability experiments
export { CoinTossConvergence, DiceRollDistribution, BirthdayProblemSimulation, ConditionalProbabilityExplorer, BinomialDistributionShape, GeometricDistributionBehavior, MonteCarloEstimation, } from './generated/probability.js';
// Statistics experiments
export { MeanVsMedianSensitivity, StandardDeviationEffects, CorrelationCoefficientBehavior, RegressionLineFitting, OutlierImpactAnalysis, SamplingDistributionShape, ConfidenceIntervalWidth, } from './generated/statistics.js';
// Sequences and Series experiments
export { ArithmeticSequenceSum, GeometricSeriesConvergence, FibonacciRatioConvergence, HarmonicSeriesDivergence, RecursiveSequenceBehavior, PartialSumVisualization, LimitApproximation, } from './generated/sequences.js';
// Mathematical Modeling experiments
export { LinearModelFitting, ExponentialDecayModeling, LogisticGrowthCurve, CompoundInterestAccumulation, OptimizationProblemSolving, RateOfChangeInterpretation, } from './generated/modeling.js';
// Linear Algebra experiments
export { MatrixMultiplicationProperties, DeterminantGeometricMeaning, EigenvalueComputation, VectorSpaceBasis, LinearTransformationEffects, MatrixInverseExistence, SystemSolutionSpace, } from './generated/linear-algebra.js';
// Calculus experiments
export { LimitEpsilonDeltaApproach, DerivativeAsSlope, ChainRuleVerification, OptimizationCriticalPoints, DefiniteIntegralAsArea, FundamentalTheoremConnection, RelatedRatesInvestigation, TaylorSeriesApproximation, DifferentialEquationSolutions, AreaBetweenCurves, } from './generated/calculus.js';
// Discrete Mathematics experiments
export { CountingPermutations, CombinationSelection, RecurrenceRelationSolving, PigeonholePrincipleApplication, InclusionExclusionCounting, BooleanAlgebraSimplification, } from './generated/discrete-math.js';
// Graphs and Networks experiments
export { DegreeDistribution, TreeProperties, CycleDetection, BipartiteGraphTesting, NetworkFlowCapacity, GraphColoringMinimum, GraphConnectivity, ShortestPathFinding, EulerPathExistence, } from './generated/graphs-networks.js';
// Optimization experiments
export { LinearProgrammingFeasibility, GradientDescentConvergence, ConstraintSatisfaction, MinimaxGameTheory, SimplexMethodIteration, ConvexityAnalysis, } from './generated/optimization.js';
// ============================================================================
// EXPERIMENT ARRAYS BY CATEGORY
// ============================================================================
import { PrimeDistributionExplorer, DivisibilityPatternInvestigator, GCDLCMRelationshipLab, ModularArithmeticCycles, DecimalExpansionBehavior, PerfectNumberInvestigation, FactorialGrowthAnalysis, BaseConversionPatterns, } from './generated/number-systems.js';
import { QuadraticRootBehavior, PolynomialDegreeEffects, SystemOfEquationsSolutionSpace, InequalityRegionMapping, AbsoluteValueTransformations, ExponentialVsLinearGrowth, LogarithmicScalingBehavior, ComplexNumberPlaneMapping, } from './generated/algebra.js';
import { DomainRangeExplorer, CompositionOfFunctions, InverseFunctionSymmetry, PiecewiseFunctionContinuity, EvenOddFunctionSymmetry, FunctionTranslationEffects, PeriodicFunctionBehavior, } from './generated/functions.js';
import { TriangleInequalityInvestigation, CircleChordProperties, AngleSumVerification, SimilarityRatioEffects, CoordinateDistanceFormula, LocusPointInvestigation, TransformationComposition, } from './generated/geometry.js';
import { UnitCircleExploration, SineWaveParameterEffects, TrigonometricIdentityVerification, PhaseShiftAnalysis, AmplitudeAndPeriodRelationship, InverseTrigDomainBehavior, LawOfSinesCosinesApplication, PolarCoordinateMapping, } from './generated/trigonometry.js';
import { CoinTossConvergence, DiceRollDistribution, BirthdayProblemSimulation, ConditionalProbabilityExplorer, BinomialDistributionShape, GeometricDistributionBehavior, MonteCarloEstimation, } from './generated/probability.js';
import { MeanVsMedianSensitivity, StandardDeviationEffects, CorrelationCoefficientBehavior, RegressionLineFitting, OutlierImpactAnalysis, SamplingDistributionShape, ConfidenceIntervalWidth, } from './generated/statistics.js';
import { ArithmeticSequenceSum, GeometricSeriesConvergence, FibonacciRatioConvergence, HarmonicSeriesDivergence, RecursiveSequenceBehavior, PartialSumVisualization, LimitApproximation, } from './generated/sequences.js';
import { LinearModelFitting, ExponentialDecayModeling, LogisticGrowthCurve, CompoundInterestAccumulation, OptimizationProblemSolving, RateOfChangeInterpretation, } from './generated/modeling.js';
import { MatrixMultiplicationProperties, DeterminantGeometricMeaning, EigenvalueComputation, VectorSpaceBasis, LinearTransformationEffects, MatrixInverseExistence, SystemSolutionSpace, } from './generated/linear-algebra.js';
import { LimitEpsilonDeltaApproach, DerivativeAsSlope, ChainRuleVerification, OptimizationCriticalPoints, DefiniteIntegralAsArea, FundamentalTheoremConnection, RelatedRatesInvestigation, TaylorSeriesApproximation, DifferentialEquationSolutions, AreaBetweenCurves, } from './generated/calculus.js';
import { CountingPermutations, CombinationSelection, RecurrenceRelationSolving, PigeonholePrincipleApplication, InclusionExclusionCounting, BooleanAlgebraSimplification, } from './generated/discrete-math.js';
import { DegreeDistribution, TreeProperties, CycleDetection, BipartiteGraphTesting, NetworkFlowCapacity, GraphColoringMinimum, GraphConnectivity, ShortestPathFinding, EulerPathExistence, } from './generated/graphs-networks.js';
import { LinearProgrammingFeasibility, GradientDescentConvergence, ConstraintSatisfaction, MinimaxGameTheory, SimplexMethodIteration, ConvexityAnalysis, } from './generated/optimization.js';
/**
 * All Number Systems experiments
 */
export const numberSystemsExperiments = [
    PrimeDistributionExplorer,
    DivisibilityPatternInvestigator,
    GCDLCMRelationshipLab,
    ModularArithmeticCycles,
    DecimalExpansionBehavior,
    PerfectNumberInvestigation,
    FactorialGrowthAnalysis,
    BaseConversionPatterns,
];
/**
 * All Algebra experiments
 */
export const algebraExperiments = [
    QuadraticRootBehavior,
    PolynomialDegreeEffects,
    SystemOfEquationsSolutionSpace,
    InequalityRegionMapping,
    AbsoluteValueTransformations,
    ExponentialVsLinearGrowth,
    LogarithmicScalingBehavior,
    ComplexNumberPlaneMapping,
];
/**
 * All Functions experiments
 */
export const functionsExperiments = [
    DomainRangeExplorer,
    CompositionOfFunctions,
    InverseFunctionSymmetry,
    PiecewiseFunctionContinuity,
    EvenOddFunctionSymmetry,
    FunctionTranslationEffects,
    PeriodicFunctionBehavior,
];
/**
 * All Geometry experiments
 */
export const geometryExperiments = [
    TriangleInequalityInvestigation,
    CircleChordProperties,
    AngleSumVerification,
    SimilarityRatioEffects,
    CoordinateDistanceFormula,
    LocusPointInvestigation,
    TransformationComposition,
];
/**
 * All Trigonometry experiments
 */
export const trigonometryExperiments = [
    UnitCircleExploration,
    SineWaveParameterEffects,
    TrigonometricIdentityVerification,
    PhaseShiftAnalysis,
    AmplitudeAndPeriodRelationship,
    InverseTrigDomainBehavior,
    LawOfSinesCosinesApplication,
    PolarCoordinateMapping,
];
/**
 * All Probability experiments
 */
export const probabilityExperiments = [
    CoinTossConvergence,
    DiceRollDistribution,
    BirthdayProblemSimulation,
    ConditionalProbabilityExplorer,
    BinomialDistributionShape,
    GeometricDistributionBehavior,
    MonteCarloEstimation,
];
/**
 * All Statistics experiments
 */
export const statisticsExperiments = [
    MeanVsMedianSensitivity,
    StandardDeviationEffects,
    CorrelationCoefficientBehavior,
    RegressionLineFitting,
    OutlierImpactAnalysis,
    SamplingDistributionShape,
    ConfidenceIntervalWidth,
];
/**
 * All Sequences and Series experiments
 */
export const sequencesExperiments = [
    ArithmeticSequenceSum,
    GeometricSeriesConvergence,
    FibonacciRatioConvergence,
    HarmonicSeriesDivergence,
    RecursiveSequenceBehavior,
    PartialSumVisualization,
    LimitApproximation,
];
/**
 * All Mathematical Modeling experiments
 */
export const modelingExperiments = [
    LinearModelFitting,
    ExponentialDecayModeling,
    LogisticGrowthCurve,
    CompoundInterestAccumulation,
    OptimizationProblemSolving,
    RateOfChangeInterpretation,
];
/**
 * All Linear Algebra experiments
 */
export const linearAlgebraExperiments = [
    MatrixMultiplicationProperties,
    DeterminantGeometricMeaning,
    EigenvalueComputation,
    VectorSpaceBasis,
    LinearTransformationEffects,
    MatrixInverseExistence,
    SystemSolutionSpace,
];
/**
 * All Calculus experiments
 */
export const calculusExperiments = [
    LimitEpsilonDeltaApproach,
    DerivativeAsSlope,
    ChainRuleVerification,
    OptimizationCriticalPoints,
    DefiniteIntegralAsArea,
    FundamentalTheoremConnection,
    RelatedRatesInvestigation,
    TaylorSeriesApproximation,
    DifferentialEquationSolutions,
    AreaBetweenCurves,
];
/**
 * All Discrete Mathematics experiments
 */
export const discreteMathExperiments = [
    CountingPermutations,
    CombinationSelection,
    RecurrenceRelationSolving,
    PigeonholePrincipleApplication,
    InclusionExclusionCounting,
    BooleanAlgebraSimplification,
];
/**
 * All Graphs and Networks experiments
 */
export const graphsNetworksExperiments = [
    DegreeDistribution,
    TreeProperties,
    CycleDetection,
    BipartiteGraphTesting,
    NetworkFlowCapacity,
    GraphColoringMinimum,
    GraphConnectivity,
    ShortestPathFinding,
    EulerPathExistence,
];
/**
 * All Optimization experiments
 */
export const optimizationExperiments = [
    LinearProgrammingFeasibility,
    GradientDescentConvergence,
    ConstraintSatisfaction,
    MinimaxGameTheory,
    SimplexMethodIteration,
    ConvexityAnalysis,
];
/**
 * All generated mathematics experiments
 */
export const allMathematicsExperiments = [
    ...numberSystemsExperiments,
    ...algebraExperiments,
    ...functionsExperiments,
    ...geometryExperiments,
    ...trigonometryExperiments,
    ...probabilityExperiments,
    ...statisticsExperiments,
    ...sequencesExperiments,
    ...modelingExperiments,
    ...linearAlgebraExperiments,
    ...calculusExperiments,
    ...discreteMathExperiments,
    ...graphsNetworksExperiments,
    ...optimizationExperiments,
];
/**
 * Total count of generated mathematics experiments
 */
export const mathematicsExperimentCount = {
    numberSystems: numberSystemsExperiments.length,
    algebra: algebraExperiments.length,
    functions: functionsExperiments.length,
    geometry: geometryExperiments.length,
    trigonometry: trigonometryExperiments.length,
    probability: probabilityExperiments.length,
    statistics: statisticsExperiments.length,
    sequences: sequencesExperiments.length,
    modeling: modelingExperiments.length,
    linearAlgebra: linearAlgebraExperiments.length,
    calculus: calculusExperiments.length,
    discreteMath: discreteMathExperiments.length,
    graphsNetworks: graphsNetworksExperiments.length,
    optimization: optimizationExperiments.length,
    total: allMathematicsExperiments.length,
};
/**
 * Manual mathematics experiments - currently none, all are generated
 */
export const MANUAL_MATHEMATICS_EXPERIMENTS = [];
/**
 * Generated mathematics experiments - these are GeneratedExperimentClass instances
 * created from ExperimentSchema using the declarative framework
 */
export const GENERATED_MATHEMATICS_EXPERIMENTS = [
    ...allMathematicsExperiments,
];
/**
 * Combined configs for backward compatibility.
 * For generated experiments, extracts the config from the class.
 */
export const MATHEMATICS_EXPERIMENTS = [
    ...GENERATED_MATHEMATICS_EXPERIMENTS.map((ExpClass) => {
        const instance = new ExpClass();
        return instance.config;
    }),
];
// ============================================================================
// ALL_* EXPERIMENT COLLECTIONS
// ============================================================================
/**
 * All Geometry experiments - alias for geometryExperiments
 */
export const ALL_GEOMETRY = geometryExperiments;
/**
 * All Trigonometry experiments - alias for trigonometryExperiments
 */
export const ALL_TRIGONOMETRY = trigonometryExperiments;
/**
 * All Probability experiments - alias for probabilityExperiments
 */
export const ALL_PROBABILITY = probabilityExperiments;
/**
 * All Statistics experiments - alias for statisticsExperiments
 */
export const ALL_STATISTICS = statisticsExperiments;
/**
 * All Sequences experiments - alias for sequencesExperiments
 */
export const ALL_SEQUENCES = sequencesExperiments;
/**
 * All Calculus experiments - alias for calculusExperiments
 */
export const ALL_CALCULUS = calculusExperiments;
/**
 * All Modeling experiments - alias for modelingExperiments
 */
export const ALL_MODELING = modelingExperiments;
// Re-export ALL_* collections from generated modules
export { ALL_LINEAR_ALGEBRA } from './generated/linear-algebra.js';
export { ALL_DISCRETE_MATH } from './generated/discrete-math.js';
export { ALL_GRAPHS } from './generated/graphs-networks.js';
export { ALL_OPTIMIZATION } from './generated/optimization.js';
//# sourceMappingURL=index.js.map